import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./login-page/login-page.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'device-dashboard-page',
    data: { name: 'Dashboard', isTab: false },
    loadChildren: () =>
      import('./device-dashboard-page/device-dashboard-page.module').then(
        (m) => m.DeviceDashboardPageModule
      ),
  },
  {
    path: 'device-details-page',
    loadChildren: () =>
      import('./device-details-page/device-details-page.module').then(
        (m) => m.DeviceDashboardPageModule
      ),
  },
  {
    path: 'login-page',
    loadChildren: () =>
      import('./login-page/login-page.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'fota-batch-details-page',
    loadChildren: () =>
      import('./fota-batch-details-page/fota-batch-details-page.module').then(
        (m) => m.DeviceFotaPageModule
      ),
  },
  {
    path: 'ota-batch-create',
    loadChildren: () =>
      import('./ota-batch-create/ota-batch-create.module').then(
        (m) => m.OtaBatchCreateModule
      ),
  },
  {
    path: 'ota-batch-page',
    loadChildren: () =>
      import('./ota-batch-page/ota-batch-page.module').then(
        (m) => m.OtaBatchPageModule
      ),
  },
  {
    path: 'govt-servers-page',
    loadChildren: () =>
      import('./govt-servers-page/govt-servers-page.module').then(
        (m) => m.GovtServersPageModule
      ),
  },
  {
    path: 'model-page',
    loadChildren: () =>
      import('./model-page/model-page.module').then((m) => m.ModelPageModule),
  },
  {
    path: 'model-firmware-page',
    loadChildren: () =>
      import('./model-firmware-page/model-firmware-page.module').then(
        (m) => m.ModelFirmwarePageModule
      ),
  },
  {
    path: 'customer-master-page',
    loadChildren: () =>
      import('./customer-master-page/customer-master-page.module').then(
        (m) => m.CustomerMasterPageModule
      ),
  },
  {
    path: 'user-tab-page',
    loadChildren: () =>
      import('./user-tab-page/user-tab-page.module').then(
        (m) => m.UserTabPageModule
      ),
  },
  {
    path: 'user-role-page',
    loadChildren: () =>
      import('./user-role-page/user-role-page.module').then(
        (m) => m.UserRolePageModule
      ),
  },
  {
    path: 'roles-group-page',
    loadChildren: () =>
      import('./roles-group-page/roles-group-page-routing.module').then(
        (m) => m.RolesGroupPageRoutingModule
      ),
  },
  {
    path: 'profile-page',
    loadChildren: () =>
      import('./profile-page/profile-page.module').then(
        (m) => m.ProfilePageModule
      ),
  },
  {
    path: 'govt-servers-add-page',
    loadChildren: () =>
      import('./govt-servers-add-page/govt-servers-add-page.module').then(
        (m) => m.GovtServersAddPageModule
      ),
  },
  {
    path: 'dispatch-device-page',
    loadChildren: () =>
      import('./dispatch-device-page/dispatch-device-page.module').then(
        (m) => m.DispatchDevicePageModule
      ),
  },
  {
    path: 'production-device-page',
    loadChildren: () =>
      import('./production-device-page/production-device-page.module').then(
        (m) => m.ProductionDevicePageModule
      ),
  },
  {
    path: 'production-device-add-page',
    loadChildren: () =>
      import(
        './production-device-add-page/production-device-add-page.module'
      ).then((m) => m.ProductionDeviceAddPageModule),
  },
  {
    path: 'fota-batch',
    loadChildren: () =>
      import('./fota-batch-page/fota-batch.module').then(
        (m) => m.FotaBatchPageModule
      ),
  },
  {
    path: 'dispatch-device',
    loadChildren: () =>
      import('./dispatch-device/dispatch-device.module').then(
        (m) => m.DispatchDevicePageModule
      ),
  },
  {
    path: 'ota-batch-view',
    loadChildren: () =>
      import('./ota-batch-details/ota-batch-detailsmodule').then(
        (m) => m.OtaBatchDetailsModule
      ),
  },
  {
    path: 'dispatch-device-add-page',
    loadChildren: () =>
      import('./dispatch-device-add-page/dispatch-device-add-page.module').then(
        (m) => m.DispatchDeviceAddPageModule
      ),
  },
  {
    path: 'production-device',
    loadChildren: () =>
      import('./production-device/production-device.module').then(
        (m) => m.ProductionDevicePageModule
      ),
  },
  {
    path: 'sampark-eol-page',
    loadChildren: () =>
      import('./sampark-eol-page/sampark-eol-page.module').then(
        (m) => m.SamparkEolPageModule
      ),
  },
  {
    path: 'sampark-eol-device-add-page',
    loadChildren: () =>
      import(
        './sampark-eol-device-add-page/sampark-eol-device-add-page.module'
      ).then((m) => m.SamparkEolDeviceAddPageModule),
  },
  {
    path: 'ota-master',
    loadChildren: () =>
      import('./ota-master/ota-master.module').then((m) => m.OtaMasterModule),
  },
  {
    path: 'rolesGroupPage',
    loadChildren: () =>
      import('./roles-group-page/roles-group-page.module').then(
        (m) => m.RolesGroupPageModule
      ),
  },
  {
    path: 'manual-fota',
    loadChildren: () =>
      import('./manual-fota-page/manual-fota-page.module').then(
        (m) => m.ManualFotaPageModule
      ),
  },
  {
    path: 'manual-ota',
    loadChildren: () =>
      import('./manual-ota-page/manual-ota-page.module').then(
        (m) => m.ManualOtaPageModule
      ),
  },
  {
    path: 'sensorise-sim-data-details',
    loadChildren: () =>
      import(
        './sensorise-sim-data-details/sensorise-sim-data-details.module'
      ).then((m) => m.SensoriseSimDataPageModule),
  },
  {
    path: 'sensorise-sim-manual-upload',
    loadChildren: () =>
      import(
        './sensorise-sim-manual-upload/sensorise-sim-manual-upload.module'
      ).then((m) => m.SensoriseSimManualUploadPageModule),
  },
  {
    path: 'firmware-master',
    loadChildren: () =>
      import('./firmware-master/firmware-master.module').then(
        (m) => m.FirmwareMasterModule
      ),
  },
  {
    path: 'dealers-management',
    loadChildren: () =>
      import('./dealers-management/dealers-management.module').then(
        (m) => m.DealersManagementModule
      ),
  },
  {
    path: 'dealers-ota',
    loadChildren: () =>
      import('./dealers-ota-page/dealers-ota-page.module').then(
        (m) => m.DealersOtaPageModule
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/login',
  },
];
